import PageTabs from './PageTabs';
import BotLicenseBanner from './BotLicenseBanner';
import { GrantTypes } from '../services/grantsApi';

const TABS = [
    { href: '/sellbot', icon: 'fa-gauge', label: 'SELLBOT_TAB_OVERVIEW', exact: true, flag: null },
    { href: '/sellbot/offers', icon: 'fa-tags', label: 'SELLBOT_TAB_OFFERS', exact: false, flag: null },
    { href: '/sellbot/transactions', icon: 'fa-receipt', label: 'SELLBOT_TAB_TRANSACTIONS', exact: false, flag: null },
    { href: '/sellbot/activity', icon: 'fa-stream', label: 'SELLBOT_TAB_ACTIVITY', exact: false, flag: null },
    { href: '/sellbot/stats', icon: 'fa-chart-line', label: 'SELLBOT_TAB_STATS', exact: false, flag: null },
    { href: '/sellbot/holograms', icon: 'fa-comment-dots', label: 'SELLBOT_TAB_HOLOGRAMS', exact: false, flag: 'SELLBOT_HOLOGRAMS' },
    { href: '/sellbot/grants', icon: 'fa-ticket', label: 'SELLBOT_TAB_GRANTS', exact: false, flag: 'SELLBOT_GRANTS' },
    { href: '/sellbot/config', icon: 'fa-sliders', label: 'SELLBOT_TAB_CONFIG', exact: false, flag: null },
    { href: '/sellbot/selftest', icon: 'fa-stethoscope', label: 'SELLBOT_TAB_SELFTEST', exact: false, flag: null },
] as const;

export default function SellbotNav() {
    return (
        <>
            <PageTabs tabs={TABS} />
            <BotLicenseBanner licenseType={GrantTypes.SellbotSeat} />
        </>
    );
}
